import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InvestmentDetailResponse, fetchEquityDetail } from "@features/investments/api";

export const equityDetailQueryKey = (ticker: string) => ["investments", "equity-detail", ticker] as const;

export function useEquityDetailQuery(ticker: string, enabled = true): UseQueryResult<InvestmentDetailResponse, Error> {
  return useQuery({
    queryKey: equityDetailQueryKey(ticker),
    queryFn: () => fetchEquityDetail(ticker),
    enabled: enabled && ticker.trim() !== "",
    retry: false,
  });
}
